import axios from "axios";
import {getToken} from "./Auth";
import {BASE_URL} from "../constant/apiURL";

export const production = false;
export function getCommonHeaders(h) {
  var headers = {
    "Content-Type": "application/json",
  };
  var token = getToken();
  if (token) headers.Authorization = `Bearer ${token}`;
  if (h) headers = { ...h, ...headers };
  return headers;
}

export function getCommonHeadersFormData(h, noDefaultHeaders = false) {
  var headers = {
    "Access-Control-Allow-Origin": "*",
    accept: "*/*",
  };
  if (!noDefaultHeaders)
    Object.assign(headers, { "Content-Type": "multipart/form-data" });
  var token = getToken();
  if (token) headers.Authorization = `Bearer ${token}`;
  if (h) headers = { ...h, ...headers };
  return headers;
}

export function apiPost(endpoint, body, onSuccess, onFailure, headers) {
  axios
    .post(BASE_URL + endpoint, body, {
      headers: getCommonHeaders(headers),
    })
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      if (error.StatusCode === 401) {
      }
      if (onFailure) onFailure(error);
    });
}

export function apiGet(endpoint, onSuccess, onFailure, headers) {
  axios
    .get(BASE_URL + endpoint, {
      headers: getCommonHeaders(headers),
    })
    .then((response) => {
      if (onSuccess) onSuccess(response.data);
    })
    .catch((error) => {
      if (onFailure) onFailure(error);
    });
}

export function apiPut(endPoint, body, onSuccess, onFailure, headers) {
  axios
    .put(BASE_URL + endPoint, body, {
      headers: getCommonHeaders(headers),
    })
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      if (onFailure) onFailure(error.response.data);
    });
}

export function apiPutFormData(endPoint, body, onSuccess, headers) {
  axios
    .put(BASE_URL + endPoint, body, {
      headers: getCommonHeadersFormData(headers),
    })
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      if (error.StatusCode === 401) {
      }
      return error;
    });
}

export function apiDelete(endpoint, onSuccess, onFailure, headers) {
  axios
    .delete(BASE_URL + endpoint, {
      headers: getCommonHeaders(headers),
    })
    .then((response) => {
      if (onSuccess) onSuccess(response.data);
    })
    .catch((error) => {
      if (onFailure) onFailure(error);
    });
}

export function fileUpload(endpoint, file) {
  var myHeaders = new Headers();
  myHeaders.append("accept", "*/*");
  myHeaders.append("Authorization", "Bearer " + getToken());
  var formdata = new FormData();
  formdata.append("file", file, file.filename);
  var requestOptions = {
    method: "PUT",
    headers: myHeaders,
    body: formdata,
    redirect: "follow",
  };

  return fetch(BASE_URL + endpoint, requestOptions)
    .then((response) => response.json())
    .then((result) => {
      return result;
    })
    .catch((error) => console.log("error", error));
}

export function fileUploadImage(endpoint, file) {
  var myHeaders = new Headers();
  myHeaders.append("accept", "*/*");
  myHeaders.append("Authorization", "Bearer " + getToken());
  var formdata = new FormData();
  formdata.append("file", file);
  var requestOptions = {
    method: "PUT",
    headers: myHeaders,
    body: formdata,
    redirect: "follow",
  };

  return fetch(BASE_URL + endpoint, requestOptions)
    .then((response) => response.json())
    .then((result) => {
      return result;
    })
    .catch((error) => {});
}

export async function uploadImages(endpoint, files, userId) {
  try {
    const images = new FormData();

    images.append("image", files);
    apiPut(
      endpoint,
      {
        images,
      },
      (res) => {}
    );
  } catch (err) {
    console.log("err", err);
  }
}

export async function FetchAPI(
  endPoint,
  method = "GET",
  body,
  hasFile,
  file,
  onSuccess,
  onFailure,
  headers
) {
  var options = {
    method,
    headers: getCommonHeaders(headers, true),
    redirect: "follow",
  };

  if (method != "GET" && body) Object.assign(options, { body });

  if (hasFile) {
    var formdata = new FormData();
    formdata.append("file", file, file.filename);
    Object.assign(options, { body: file });
  }
  await fetch(BASE_URL + endPoint, options)
    .then((response) => response.json())
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      if (onFailure) onFailure(error);
    });
}
